<template>
  <div>
    <ul class="navbar-nav">
      <template v-for="menu in menus">
        <template v-if="menu.view === 'sharing_soc'">
          <div :key="menu.view">
            <v-dialog v-model="dialog" width="300" hide-overlay>
              <template v-slot:activator="{ on }">
                <li>
                  <a v-on="on" :title="menu.title">{{ menu.title }}</a>
                </li>
              </template>
              <v-card>
                <v-card-text>
                  <div class="share-soc">
                    <div class="share-icons">
                      <Social :url="currentUrl" />
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
        </template>
        <template
          v-else-if="menu.view === 'subscription_to_newsletters' && isLoggedIn"
        >
          <div :key="menu.view">
            <v-dialog v-model="dialog2" width="500" hide-overlay>
              <template v-slot:activator="{ on }">
                <li>
                  <a v-on="on" :title="menu.title">{{ menu.title }}</a>
                </li>
              </template>
              <v-card>
                <v-card-title>{{ $t('Подписаться на') }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px;">
                  <v-radio-group v-model="radios" column>
                    <v-radio
                      :label="$t('Категорию')"
                      value="category"
                    ></v-radio>
                    <v-radio
                      :label="$t('Разработчика')"
                      value="developer"
                    ></v-radio>
                    <v-radio
                      :label="$t('Ключевые слова')"
                      value="keyword"
                    ></v-radio>
                    <v-autocomplete
                      :items="data.refCategory"
                      v-model="subscription.category"
                      :label="$t('Выбор категории')"
                      item-value="id"
                      item-text="transName"
                      v-if="radios === 'category'"
                      multiple
                      clearable
                    ></v-autocomplete>
                    <v-autocomplete
                      :items="data.refDeveloper"
                      v-model="subscription.developer"
                      :label="$t('Выбор разработчика')"
                      item-value="id"
                      item-text="transName"
                      v-if="radios === 'developer'"
                      multiple
                      clearable
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-icon class="select-def__icon">
                          <v-icon :class="item.status === false ? 'nv_icon' : ''" x-small/>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.transName }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                    <template class="keyword-template" v-if="radios === 'keyword'">
                      <v-text-field
                        v-model="search"
                        :label="$t('Ключевые слова')"
                        dense
                        clearable
                        outlined
                      ></v-text-field>
                      <v-treeview
                        style="overflow-y: scroll; height: 80px;"
                        :search="search"
                        v-model="subscription.keyword"
                        :items="data.refKeyword"
                        item-value="id"
                        item-text="name"
                        :selection-type="'independent'"
                        selectable
                        item-disabled="locked"
                        :label="$t('Выберите ключевые слова')"
                      >
                      </v-treeview>
                    </template>
                  </v-radio-group>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                    color="blue darken-1"
                    text
                    v-bind:disabled="
                      Object.keys(subscription).length === 0 || radios === ''
                    "
                    @click=";(dialog2 = false), subscribe()"
                    >{{ $t('Оформить подписку') }}</v-btn
                  >
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="
                      ;(dialog2 = false), (radios = ''), (subscription = {})
                    "
                    >{{ $t('Закрыть') }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </template>
        <template
          v-else-if="menu.view === 'subscription_to_newsletters' && !isLoggedIn"
        >
          <div :key="menu.view">
            <v-dialog v-model="dialog3" width="300" hide-overlay>
              <template v-slot:activator="{ on }">
                <li>
                  <a v-on="on" :title="menu.title">{{ menu.title }}</a>
                </li>
              </template>
              <v-card min-height="100">
                <v-card-title style="text-align: center">
                  {{
                    $t('Вы не авторизованы для подписки на рассылки!')
                  }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn color="blue darken-1" text @click="dialog3 = false">{{
                    $t('Закрыть')
                  }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </template>
        <template v-else>
          <router-link tag="li" :to="link(menu)" :key="menu.url" :title="menu.title">
            <a href="#">{{ menu.title }}</a>
          </router-link>
        </template>
      </template>
    </ul>
  </div>
</template>

<script>
import Social from '@/components/Social'
import Api from '@/model/api'
import Subscription from '@/model/subs'
import { Trans } from "@/plugins/Translation"
import { mapGetters } from 'vuex'

export default {
  components: {
    Social
  },
  props: {
    menus: [Array, Object],
    search: String
  },
  data: () => ({
    dialog: false,
    dialog2: false,
    dialog3: false,
    radios: '',
    currentUrl: '',
    data: [],
    subscription: {}
  }),

  mounted() {
    this.currentUrl = window.location.href
  },

  created () {
    this.getData()
  },

  computed: {
    ...mapGetters({
      searchData: 'getSearchData'
    }),
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    }
  },
  methods: {
    link(menu) {
      switch (menu.view) {
        case 'page':
          return Trans.currentLocaleUrl + '/article/' + menu.slug
        case 'page_blog':
          return Trans.currentLocaleUrl + '/blog/' + menu.slug
        case 'npa_category':
          return Trans.currentLocaleUrl + '/npa/categories'
        case 'npa_developer':
          return Trans.currentLocaleUrl + '/npa/developers'
        case 'npa':
          return Trans.currentLocaleUrl + '/npa/' + menu.slug
        case 'ahchor':
          return '#'
        case 'url':
          return Trans.currentLocaleUrl + '/' + menu.url
        case 'offer':
          return Trans.currentLocaleUrl + '/offer'
        case 'law':
          return Trans.currentLocaleUrl + '/law-list/' + menu.slug
        default:
          return '#'
      }
    },
    getData() {
          this.data = this.searchData
          this.refKeyword = this.data.refKeyword
    },
    subscribe() {
      if (this.radios === 'category') {
        this.$delete(this.subscription, 'developer')
        this.$delete(this.subscription, 'keyword')
      } else if (this.radios === 'developer') {
        this.$delete(this.subscription, 'category')
        this.$delete(this.subscription, 'keyword')
      } else if (this.radios === 'keyword') {
        this.$delete(this.subscription, 'developer')
        this.$delete(this.subscription, 'category')
      } else {
        this.$delete(this.subscription, 'developer')
        this.$delete(this.subscription, 'category')
        this.$delete(this.subscription, 'keyword')
      }
      Subscription.subscribeNewsletter(this.subscription)
        .then((response) => {
          if (response.data.result === 'success') {
            alert(this.$i18n.t('Вы успешно подписаны на обновления'))
            this.getData()
          }
          if (response.data.result === 'error') {
            alert(this.$i18n.t('Ошибка подписки'))
          }
        })
        .catch((error) => {
          console.log(error)
        })
      this.subscription = {}
      this.radios = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.v-dialog {
  .share-soc {
    margin-top: 0px;
    border-top: 0;
  }
}
</style>
